<template>
    <v-content>
        <v-app>
            <v-container grid-list-xl text-xs-center fluid>
                <v-layout row wrap>
                    <v-flex xs4 py-0>
                        <v-select v-model="acquirer" :items="acquirers" label="Select An Acquirer" @change="pspHandle"></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <chargebacks-secure-trading class="pa-0" v-if="acquirer == 'Securetrading_Omnipay'"></chargebacks-secure-trading>
                   </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template> 

<script>
    import chargebacksSecureTrading from '../components/ChargebacksSecureTrading.vue';
    import sweetAlert from '../sweetAlert.js';
    import axios from 'axios';

    export default {
        data () {
            return {
                acquirer: null,
                acquirers: [{ value: 'Concardis', text: 'Concardis' },
                            { value: 'Optimalpayment', text: 'Paysafe' },
                            { value: 'Securetrading_Omnipay', text: 'Secure Trading' }]
            }
        },
        components: {
           'chargebacks-secure-trading' : chargebacksSecureTrading
        },
        methods: {
            pspHandle(value) {
                // this.state = value;
                // this.clearingInstitute = null;
                // this.clearingInstitutesList = value == 'Live' ? this.clearingInstitutesListLive : this.clearingInstitutesListTest;
                console.log(this.acquirer);
            }
        }
    }
</script>

<style>
 
</style>
